import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { SelectItem } from 'primeng/api';
import {
  ServicioOrdenamientosService,
  FitlrosOrdenServicioEntity,
  ParametrosOrdenamientosEntity
} from 'src/app/services/servicio-ordenamientos.service';

@Component({
  selector: 'app-header-orden-servicios',
  templateUrl: './header-orden-servicios.component.html',
  styleUrls: ['./header-orden-servicios.component.css']
})
export class HeaderOrdenServiciosComponent implements OnInit {

  @Input() parametros: ParametrosOrdenamientosEntity;
  @Output() filtrosSeleccionados: EventEmitter<any>;
  @Output() errorGenerado: EventEmitter<any>;

  filtros: FitlrosOrdenServicioEntity = {} as FitlrosOrdenServicioEntity;
  profesionales: SelectItem[] = [];
  procedimientos: SelectItem[] = [];

  constructor(private ordenamientosService: ServicioOrdenamientosService) {
    this.filtrosSeleccionados = new EventEmitter();
    this.errorGenerado = new EventEmitter();

    this.filtros = {
      fechaInicio: moment().format('YYYY-MM-DD'),
      fechaFin: moment().format('YYYY-MM-DD'),
      impresionServicios: false,
      discriminarNoPos: false,
      discriminarServicios: false,
      profesionales: [],
      procedimientos: []
    }
  }

  ngOnInit() {
    this.getProfesionales();
  }

  async getProfesionales() {
    const { fechaInicio, fechaFin } = this.filtros
    let response = await this.ordenamientosService
      .getProfesionalesSolicitud(this.parametros, fechaInicio, fechaFin, 1);

    this.profesionales = [];
    this.filtros.profesionales = [];
    response.subscribe((data: any) => {
      if (data && data['#result-set-1'].length > 0) {
        data['#result-set-1'].forEach(profesional => {
          this.profesionales.push({
            label: profesional['prfsnl'],
            value: profesional['unco']
          });
          this.filtros.profesionales.push(profesional['unco']);
        });
      }
      this.getProcedimientos();
    }, (error) => {
      console.log('Error HeaderOrdenServiciosComponent.getProfesionales()', error);
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de profesionales, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    });
  }

  async getProcedimientos() {
    const { fechaInicio, fechaFin } = this.filtros
    const profesionales = this.profesionales.map(prof => prof.value).toString();
    let response = await this.ordenamientosService
      .getServiciosDisponibles(this.parametros, fechaInicio, fechaFin, profesionales, 1);

    this.procedimientos = [];
    this.filtros.procedimientos = [];
    response.subscribe((data: any) => {
      if (data && data['#result-set-1'].length > 0) {
        data['#result-set-1'].forEach(procedimiento => {
          this.procedimientos.push({
            label: procedimiento['itm'],
            value: procedimiento['unco']
          });
          this.filtros.procedimientos.push(procedimiento['unco']);
        });
      }
    }, (error) => {
      console.log('Error HeaderOrdenServiciosComponent.getProcedimientos()', error);
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de procedmientos, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    });
  }

  onCambioFecha() {
    this.getProfesionales();
  }

  onGenerar() {
    const { fechaInicio, fechaFin, profesionales, procedimientos } = this.filtros;
    if (fechaInicio.length === 0) {
      this.errorGenerado.emit('<strong>Fecha Inicial</strong> debe ser una fecha válida.');
    } else if (fechaFin.length === 0) {
      this.errorGenerado.emit('<strong>Fecha Final</strong> debe ser una fecha válida.');
    } else if (profesionales.length === 0) {
      this.errorGenerado.emit('Debe seleccionar al menos un <strong>Profesional</strong>.');
    } else if (procedimientos.length === 0) {
      this.errorGenerado.emit('Debe seleccionar al menos un <strong>Procedimiento</strong>.');
    } else {
      this.filtrosSeleccionados.emit(this.filtros);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    printContents = document.getElementById('reporte-ordenes-servicios').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO"
          crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }
}
